// extracted by mini-css-extract-plugin
export default {"isAuthContainer":"isAuth_isAuthContainer__Afxa1","isAuthBody":"isAuth_isAuthBody__RiiqC"};